module.exports = __webpack_public_path__ + "static/media/chemvr3.5c4857b1.png";